<h1 *ngIf="!playerDetails" class="px-2 mx-auto">Loading...</h1>
<section *ngIf="playerDetails" class="flex flex-col justify-center mx-auto">
  <h1
    class="px-2 m-2 mb-2 text-center bg-gray-800 border border-gray-800 border-solid"
  >
    <div
      class="col-span-3 px-2 text-center border border-gray-800 border-solid"
    >
      <a [routerLink]="['/player', playerDetails.player.id]">
        <span [innerHTML]="playerDetails.player.name | safeHtml"> </span>
        ({{ playerDetails.player.id }})
      </a>
    </div>
  </h1>
  <div class="flex flex-row flex-wrap max-w-full mx-2">
    <!-- Allgemein -->
    <div class="max-w-xs mt-2 mr-2">
      <h2
        class="w-full mb-2 text-center bg-gray-800 border border-gray-800 border-solid"
      >
        Allgemein
      </h2>
      <div class="grid grid-cols-2 gap-1">
        <div class="px-2 bg-gray-800 border border-gray-800 border-solid">
          Ansehen
        </div>
        <div class="px-2 text-right border border-gray-800 border-solid">
          {{ playerDetails.player.reputation }}
        </div>
        <div class="px-2 bg-gray-800 border border-gray-800 border-solid">
          Level
        </div>
        <div class="px-2 text-right border border-gray-800 border-solid">
          {{ playerDetails.player.level }}
        </div>
        <div class="px-2 bg-gray-800 border border-gray-800 border-solid">
          Runden
        </div>
        <div class="px-2 text-right border border-gray-800 border-solid">
          {{ playerDetails.player.ticks }}
        </div>
        <div
          class="col-span-2 px-2 bg-gray-800 border border-gray-800 border-solid"
        >
          Allianz
        </div>
        <div
          class="col-span-2 px-2 break-all border border-gray-800 border-solid"
        >
          <a
            *ngIf="playerDetails.player.alliance"
            [routerLink]="['/alliance', playerDetails.player.alliance.id]"
          >
            <span [innerHTML]="playerDetails.player.alliance.name | safeHtml">
            </span>
            ({{ playerDetails.player.alliance.id }})
          </a>
          <ng-container *ngIf="!playerDetails.player.alliance">-</ng-container>
        </div>
        <div class="px-2 bg-gray-800 border border-gray-800 border-solid">
          Kolonien
        </div>
        <div class="px-2 text-right border border-gray-800 border-solid">
          {{ playerDetails.colonies.length }}
        </div>
        <div class="px-2 bg-gray-800 border border-gray-800 border-solid">
          Raumschiffe
        </div>
        <div class="px-2 text-right border border-gray-800 border-solid">
          {{ playerDetails.ships.length }}
        </div>
        <div class="px-2 bg-gray-800 border border-gray-800 border-solid">
          Aktualisiert
        </div>
        <div class="px-2 text-right border border-gray-800 border-solid">
          {{ playerDetails.player.updatedAt | date: "dd.MM.yyyy HH:mm" }}
        </div>
        <div class="px-2 bg-gray-800 border border-gray-800 border-solid">
          Erstellt
        </div>
        <div class="px-2 text-right border border-gray-800 border-solid">
          {{ playerDetails.player.createdAt | date: "dd.MM.yyyy HH:mm" }}
        </div>
        <div
          class="col-span-2 px-2 bg-gray-800 border border-gray-800 border-solid"
        >
          Punkte:
        </div>
        <div
          class="grid grid-cols-2 col-span-2 gap-1 p-1 border border-gray-800 border-solid"
        >
          <div class="px-2 bg-gray-800 border border-gray-800 border-solid">
            Wissenschaft
          </div>
          <div class="px-2 text-right border border-gray-800 border-solid">
            {{ playerDetails.player.points.research }}
          </div>
          <div class="px-2 bg-gray-800 border border-gray-800 border-solid">
            Geselschaft
          </div>
          <div class="px-2 text-right border border-gray-800 border-solid">
            {{ playerDetails.player.points.society }}
          </div>
          <div class="px-2 bg-gray-800 border border-gray-800 border-solid">
            Wirtschaft
          </div>
          <div class="px-2 text-right border border-gray-800 border-solid">
            {{ playerDetails.player.points.economy }}
          </div>
          <div class="px-2 bg-gray-800 border border-gray-800 border-solid">
            Militär
          </div>
          <div class="px-2 text-right border border-gray-800 border-solid">
            {{ playerDetails.player.points.military }}
          </div>
        </div>
      </div>
    </div>
    <!-- Kolonien -->
    <div class="mt-2 mr-2">
      <h2
        class="w-full mb-2 text-center bg-gray-800 border border-gray-800 border-solid"
      >
        Kolonien
      </h2>
      <div class="">
        <!-- <ColoniesList colonies={playerDetails.colonies} /> -->
        <table class="table border-separate">
          <thead class="">
            <tr class="">
              <th class="px-2 bg-gray-800 border border-gray-800 border-solid">
                Position
              </th>
              <th class="px-2 bg-gray-800 border border-gray-800 border-solid">
                Bild
              </th>
              <th class="px-2 bg-gray-800 border border-gray-800 border-solid">
                Name
              </th>
              <th class="px-2 bg-gray-800 border border-gray-800 border-solid">
                Aktualisiert
              </th>
              <th class="px-2 bg-gray-800 border border-gray-800 border-solid">
                Erstellt
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let colony of playerDetails.colonies">
              <td class="px-2 text-center border border-gray-800 border-solid">
                {{ colony.x + "|" + colony.y }}
              </td>
              <td class="px-2 border border-gray-800 border-solid">
                <img alt="Kolonie" src="{{ getColonyImage(colony) }}" />
              </td>
              <td
                class="max-w-xs px-2 text-right border border-gray-800 border-solid break-word"
                [innerHTML]="colony.name | safeHtml"
              ></td>
              <td class="px-2 text-right border border-gray-800 border-solid">
                {{ colony.updatedAt | date: "dd.MM.yyyy HH:mm" }}
              </td>
              <td class="px-2 text-right border border-gray-800 border-solid">
                {{ colony.createdAt | date: "dd.MM.yyyy HH:mm" }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <!-- Schiffe -->
    <div class="flex-grow mt-2">
      <h2
        class="w-full px-2 mb-2 text-center bg-gray-800 border border-gray-800 border-solid"
      >
        Schiffe
      </h2>
      <div class="mx-auto">
        <table class="table border-separate">
          <thead class="">
            <tr class="">
              <th class="px-2 bg-gray-800 border border-gray-800 border-solid">
                Position
              </th>
              <th class="px-2 bg-gray-800 border border-gray-800 border-solid">
                Bild
              </th>
              <th class="px-2 bg-gray-800 border border-gray-800 border-solid">
                Name
              </th>
              <th class="px-2 bg-gray-800 border border-gray-800 border-solid">
                NCC
              </th>
              <th class="px-2 bg-gray-800 border border-gray-800 border-solid">
                Klasse
              </th>
              <th class="px-2 bg-gray-800 border border-gray-800 border-solid">
                Hülle
              </th>
              <th class="px-2 bg-gray-800 border border-gray-800 border-solid">
                Schilde
              </th>
              <th class="px-2 bg-gray-800 border border-gray-800 border-solid">
                Aktualisiert
              </th>
              <th class="px-2 bg-gray-800 border border-gray-800 border-solid">
                Erstellt
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let ship of playerDetails.ships">
              <td class="px-2 text-center border border-gray-800 border-solid">
                {{ ship.x + "|" + ship.y }}
              </td>
              <td class="px-2 border border-gray-800 border-solid">
                <img class="" alt="Kolonie" src="{{ getShipsImage(ship) }}" />
              </td>
              <td
                class="max-w-xs px-2 text-right border border-gray-800 border-solid break-word"
                [innerHTML]="ship.name | safeHtml"
              ></td>

              <td class="px-2 text-right border border-gray-800 border-solid">
                {{ ship.ncc }}
              </td>
              <td class="px-2 text-right border border-gray-800 border-solid">
                {{ ship.objectClass }}
              </td>
              <td class="px-2 text-center border border-gray-800 border-solid">
                {{
                  ship.shieldsActive ? "-" : ship.huell + "/" + ship.huellMax
                }}
              </td>
              <td class="px-2 text-center border border-gray-800 border-solid">
                {{
                  ship.shieldsActive
                    ? ship.shields + "/" + ship.shieldsMax
                    : "-"
                }}
              </td>
              <td class="px-2 text-right border border-gray-800 border-solid">
                {{ ship.updatedAt | date: "dd.MM.yyyy HH:mm" }}
              </td>
              <td class="px-2 text-right border border-gray-800 border-solid">
                {{ ship.createdAt | date: "dd.MM.yyyy HH:mm" }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <!-- Versionierung -->
    <div class="flex-grow mt-2">
      <h2
        class="w-full px-2 mb-2 text-center bg-gray-800 border border-gray-800 border-solid"
      >
        Versionierung:
      </h2>
      <div class="mx-auto">
        <table class="table border-separate">
          <thead class="">
            <tr class="">
              <th class="px-2 bg-gray-800 border border-gray-800 border-solid">
                Name
              </th>
              <th class="px-2 bg-gray-800 border border-gray-800 border-solid">
                Ansehen
              </th>
              <th class="px-2 bg-gray-800 border border-gray-800 border-solid">
                Level
              </th>
              <th class="px-2 bg-gray-800 border border-gray-800 border-solid">
                Runden
              </th>
              <th class="px-2 bg-gray-800 border border-gray-800 border-solid">
                Allianz
              </th>
              <th class="px-2 bg-gray-800 border border-gray-800 border-solid">
                <span class="hidden half-hd:inline">Wissenschaft</span>
                <span class="half-hd:hidden">Wiss.</span>
              </th>
              <th class="px-2 bg-gray-800 border border-gray-800 border-solid">
                <span class="hidden half-hd:inline">Geselschaft</span>
                <span class="half-hd:hidden">Ges.</span>
              </th>
              <th class="px-2 bg-gray-800 border border-gray-800 border-solid">
                <span class="hidden half-hd:inline">Wirtschaft</span>
                <span class="half-hd:hidden">Wirt.</span>
              </th>
              <th class="px-2 bg-gray-800 border border-gray-800 border-solid">
                <span class="hidden half-hd:inline">Militär</span>
                <span class="half-hd:hidden">Mil.</span>
              </th>
              <th class="px-2 bg-gray-800 border border-gray-800 border-solid">
                Aktualisiert
              </th>
              <th class="px-2 bg-gray-800 border border-gray-800 border-solid">
                Erstellt / Überschrieben
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td
                class="max-w-xs px-2 text-right border border-gray-800 border-solid break-word"
                [innerHTML]="playerDetails.player.name | safeHtml"
              ></td>
              <td class="px-2 text-right border border-gray-800 border-solid">
                {{ playerDetails.player.reputation }}
              </td>
              <td class="px-2 text-right border border-gray-800 border-solid">
                {{ playerDetails.player.level }}
              </td>
              <td class="px-2 text-right border border-gray-800 border-solid">
                {{ playerDetails.player.ticks }}
              </td>
              <td class="px-2 text-right border border-gray-800 border-solid">
                <a
                  *ngIf="playerDetails.player.alliance"
                  [routerLink]="['/alliance', playerDetails.player.alliance.id]"
                >
                  <span
                    [innerHTML]="playerDetails.player.alliance.name | safeHtml"
                  >
                  </span>
                  ({{ playerDetails.player.alliance.id }})
                </a>
                <ng-container *ngIf="!playerDetails.player.alliance"
                  >-</ng-container
                >
              </td>
              <td class="px-2 text-right border border-gray-800 border-solid">
                {{ playerDetails.player.points.research }}
              </td>
              <td class="px-2 text-right border border-gray-800 border-solid">
                {{ playerDetails.player.points.society }}
              </td>
              <td class="px-2 text-right border border-gray-800 border-solid">
                {{ playerDetails.player.points.economy }}
              </td>
              <td class="px-2 text-right border border-gray-800 border-solid">
                {{ playerDetails.player.points.military }}
              </td>
              <td class="px-2 text-right border border-gray-800 border-solid">
                {{ playerDetails.player.updatedAt | date: "dd.MM.yyyy HH:mm" }}
              </td>
              <td class="px-2 text-right border border-gray-800 border-solid">
                {{ playerDetails.player.createdAt | date: "dd.MM.yyyy HH:mm" }}
              </td>
            </tr>
            <tr *ngFor="let history of playerDetails.histories">
              <td
                class="max-w-xs px-2 text-right border border-gray-800 border-solid break-word"
                [innerHTML]="history.name | safeHtml"
              ></td>
              <td class="px-2 text-right border border-gray-800 border-solid">
                {{ history.reputation }}
              </td>
              <td class="px-2 text-right border border-gray-800 border-solid">
                {{ history.level }}
              </td>
              <td class="px-2 text-right border border-gray-800 border-solid">
                {{ history.ticks }}
              </td>
              <td class="px-2 text-right border border-gray-800 border-solid">
                <a
                  *ngIf="history.alliance"
                  [routerLink]="['/alliance', history.alliance.id]"
                >
                  <span [innerHTML]="history.alliance.name | safeHtml"> </span>
                  ({{ history.alliance.id }})
                </a>
                <ng-container *ngIf="!history.alliance">-</ng-container>
              </td>
              <td class="px-2 text-right border border-gray-800 border-solid">
                {{ history.points.research }}
              </td>
              <td class="px-2 text-right border border-gray-800 border-solid">
                {{ history.points.society }}
              </td>
              <td class="px-2 text-right border border-gray-800 border-solid">
                {{ history.points.economy }}
              </td>
              <td class="px-2 text-right border border-gray-800 border-solid">
                {{ history.points.military }}
              </td>
              <td class="px-2 text-right border border-gray-800 border-solid">
                {{ history.updatedAt | date: "dd.MM.yyyy HH:mm" }}
              </td>
              <td class="px-2 text-right border border-gray-800 border-solid">
                {{ history.overriddenAt | date: "dd.MM.yyyy HH:mm" }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</section>
